module.exports = __webpack_public_path__ + "static/media/no_image.855e8ca0.jpg";